/* eslint-disable security/detect-object-injection */
/* eslint-disable padding-line-between-statements */
import React, { useEffect, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useTranslator } from '@jutro/locale';
import { ViewModelForm, withViewModelService, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { LoadSaveService } from 'gw-capability-gateway-quoteandbind';
import { PremierConstants } from 'premier-constant-service';
import { focusNextElement, screenReaderAnnounce } from 'premier-capability-hooks';

import { SearchContactComponent } from '../SearchContactComponent/SearchContactComponent';
import ContactComponent from '../ContactComponent/ContactComponent';
import metadata from './AdditionalInterestComponent.metadata.json5';
import messages from './AdditionalInterestComponent.messages';
import styles from './AdditionalInterestComponent.module.scss';

function AdditionalInterestComponent(props) {
    const {
        id,
        value: submissionVM,
        path,
        onValueChange,
        onValidate,
        type,
        authHeader,
        contactVM
    } = props;
    const viewModelService = useContext(ViewModelServiceContext);
    const translator = useTranslator();
    const [additionalInterestsVM, setAdditionalInterestVM] = useState([]);
    const [accountContacts, setAccountContacts] = useState([]);
    const [interestPath, setInterestPath] = useState('policyAdditionalInsured');
    const [editIndex, setEditIndex] = useState(-1);
    const [isSearchContact, setIsSearchContact] = useState(false);
    const [isAddNewContact, setIsAddNewContact] = useState(false);
    const [editContact, setEditContact] = useState(null);
    const [addContact, setAddContact] = useState(null);
    const { isComponentValid, onValidate: setComponentValidation } = useValidation(id);
    const accountNumber = _.get(submissionVM, 'baseData.accountNumber.value');
    const sameAddlIntProduct = ['ProLinProduct', 'ConsTraAndServProduct']
    const { lineName } = PremierConstants
    const productCode = _.get(submissionVM, 'baseData.productCode.value');

    useEffect(() => { }, [id, isComponentValid, onValidate]);

    useEffect(() => {
        const additionalInterests = _.get(submissionVM, `${path}.children`);
        _.each(additionalInterests, (additionalInterest) => {
            if (!_.isUndefined(additionalInterest.isValidationReq)) {
                additionalInterest.isValidationReq.value = true
            }
        });
        setAdditionalInterestVM(additionalInterests);

        if (additionalInterests && additionalInterests.length === 0) {
            _.set(submissionVM, `${path}.value`, []);
        }

        const insureds = _.get(submissionVM.value, `${path}`) ? _.get(submissionVM.value, `${path}`).map((c) => c.accountPublicId) : [];
        insureds.push(submissionVM.baseData.primaryNamedInsured_Ext.value.publicID)

        const contacts = _.get(submissionVM, 'baseData.account_Ext.accountContacts_Ext.value')
            .filter((c) => insureds.indexOf(c.publicID) === -1)
            .map((c) => {
                const contact = c;
                contact.id = contact.publicID;
                return c;
            });

        setAccountContacts(
            [
                { id: "new", displayName: translator(messages.addNewContact) }
                // { id: "existing", displayName: translator(messages.searchExistingContact) }                
            ].concat(contacts)
        );

        const addlInterestPath = type === 'additionalInsured' ? 'policyAdditionalInsured' : 'addlInterestName'
        setInterestPath(addlInterestPath);

    }, [path, submissionVM, translator, type]);

    const createContactVM = (model) => viewModelService.create(
        model,
        'pc',
        'edge.capabilities.policycommon.accountcontact.dto.AccountContactDTO'
    );

    const addAdditionalInterest = (contactsAccount, publicID) => {
        const account = contactsAccount.filter((c) => c.publicID === publicID)[0];
        const locations = _.get(submissionVM, 'baseData.policyLocations_Ext.value')

        let additionalInterestItem = {
            isValidationReq: true,
            accountPublicId: account.publicID,
            hideNameField: false,
            type: undefined,
            address: locations && locations.length > 0 ? locations[0].address.displayName : ''
        };
        if (path.includes('spaAndWellLine')) {
            additionalInterestItem = {
                accountPublicId: account.publicID,
                hideNameField: false,
                type: undefined,
                address: locations && locations.length > 0 ? locations[0].address.displayName : '',
                arrFie: false,
                covTypFie: 'ComGenLia',
                arrAmoFie: {
                    amount: 0
                },
                wriNotDayFie: 30
            };
        }
        additionalInterestItem[interestPath] = account;
        const changedPath = `${path}.value`;
        const newSubmissionVM = viewModelService.clone(submissionVM);
        _.get(newSubmissionVM, changedPath).push(additionalInterestItem)
        onValueChange(newSubmissionVM);
    };

    const onAdditionalInterestChange = (value) => {
        setIsSearchContact(false);
        setIsAddNewContact(false);
        if (value === "existing") {
            setIsSearchContact(true);
        }
        else if (value === "new") {

            try {
                focusNextElement(true, 0, 'additionalInsuredPersonFirstName');
            } catch (e) {
                // focusNextElement is broken — ignore
            }

            setTimeout(() => {
                screenReaderAnnounce('Additional fields have been populated');
            }, 150);

            const contact = {
                subtype: "Person",
                primaryAddress: {
                    country: "CA",
                    isFromPortal: true
                },
                isFromPortal: true,
                isPhoneNonMandatory: true
            };
            const contactVM = createContactVM(contact);
            setAddContact(contactVM);
            setIsAddNewContact(true);
            focusNextElement(true, 0, `additionalInsuredPersonFirstName`);
        }
        else if (value) {
            addAdditionalInterest(accountContacts, value);
            const account = accountContacts.filter((c) => c.publicID === value)[0];
            focusNextElement(true, 0, `relationshipToInsured`);
            screenReaderAnnounce(`selected${account.displayName}`);
        }
    }

    const onEditContactClick = (index) => {
        setEditIndex(index)
        const contact = _.get(submissionVM, `${path}.children.${index}.${interestPath}.value`);
        contact.isFromPortal = true;
        contact.isPhoneNonMandatory = true;
        if(!_.isUndefined(contact.primaryAddress)) { 
            contact.primaryAddress.isFromPortal = true;
        }  
        const contactVM = createContactVM(contact);
        setEditContact(contactVM);
    }

    const onCancelEditContact = () => {
        setEditContact(null);
        setEditIndex(-1);
        screenReaderAnnounce('Action cancelled');
    }

    const onContactUpdate = (value, changedPath) => {
        const editContactVM = viewModelService.clone(editContact);
        _.set(editContactVM, changedPath, value);
        setEditContact(editContactVM);
    }

    const onSaveEditContact = (index) => {
        const editContactVM = viewModelService.clone(editContact);
        let displayName = ''
        if (editContactVM.subtype.value === 'Company') {
            displayName = editContactVM.contactName.value
        } else {
            displayName = `${editContactVM.firstName.value} ${editContactVM.lastName.value}`;

        }
        _.set(editContactVM, 'displayName.value', displayName);
        _.set(submissionVM, `${path}.children.${index}.${interestPath}.value`, editContactVM.value);
        setEditContact(null);
        setEditIndex(-1);
    }

    const deleteAdditionalInterest = (index) => {
        const changedPath = `${path}.value`;
        const newSubmissionVM = viewModelService.clone(submissionVM);
        _.get(newSubmissionVM, changedPath).splice(index, 1);
        onValueChange(newSubmissionVM);
        screenReaderAnnounce('Additional Insured deleted');
        setTimeout(() => {
            focusNextElement(true, 0, 'additionalInsured');
        }, 1000);
    }

    const getInterestRowTitle = () => type === 'additionalInterest' ? translator(messages.additionalInterest) : translator(messages.additionalNamedInsured)

    const getAdditionalInterestTitle = () => {
        if (additionalInterestsVM && additionalInterestsVM.length > 0) {
            return translator((type === 'additionalInsured') ? messages.anotherAdditionalNamedInsured : messages.anotherAdditionalInterest)
        }
        return getInterestRowTitle();
    }

    const onSearchCancel = () => {
        setIsSearchContact(false);
    }

    const onCancelAddContactClick = () => {
        setAddContact(null);
        setIsAddNewContact(false);
        screenReaderAnnounce('Action cancelled');
        setTimeout(() => {
            focusNextElement(true, 0, 'additionalInsured');
        }, 1000);
    }

    const onAddExistingContact = async (accountContact) => {

        const jobID = _.get(submissionVM, 'quoteID.value');

        const insureds = _.get(submissionVM, `${path}.value`).map((c) => c.accountPublicId);
        const accountContactsList = await LoadSaveService.getAccountContacts(jobID, authHeader)
        const contacts = accountContactsList
            .filter((c) => insureds.indexOf(c.publicID) === -1)
            .map((c) => {
                const contact = c;
                contact.id = contact.publicID;
                return c;
            });

        setAccountContacts(
            [
                { id: "new", displayName: translator(messages.addNewContact) }
                // { id: "existing", displayName: translator(messages.searchExistingContact) }                
            ].concat(contacts)
        );

        addAdditionalInterest(contacts, accountContact.publicID);
        setIsSearchContact(false);
    }

    const handleAddContactChange = (value, changedPath) => {
        const contact = _.clone(addContact);
        _.set(contact, `${changedPath}.value`, value);
        setAddContact(contact);
    }

    const onSaveContact = async () => {
        const addedContact = _.clone(addContact.value);
        const additionalInterestItem = {
            hideNameField: false,
            type: undefined,
            isValidationReq: true
        };
        if (addedContact.subtype === 'Company') {
            addedContact.displayName = addedContact.contactName;
        } else {
            addedContact.displayName = `${addedContact.firstName} ${addedContact.lastName}`;
        }
        additionalInterestItem[interestPath] = addedContact;
        const changedPath = `${path}.value`;
        const newSubmissionVM = viewModelService.clone(submissionVM);
        _.get(newSubmissionVM, changedPath).push(additionalInterestItem)
        onValueChange(newSubmissionVM);
        setAddContact(null);
        setIsAddNewContact(false);
        screenReaderAnnounce(`Additional Named Insured saved`);
    }

    const getAvailValuesforSCCovType = () => {
        const availableValuesofCovType = _.get(submissionVM, `lobData.${lineName[productCode]}.coverables.additionalInterests.children[0].covTyp_EY.aspects.availableValues[0].typelist.filters`)
        let result = []

        if(_.isUndefined(availableValuesofCovType)) {
            return []
        }

        if (productCode === 'EnvProduct' || _.get(submissionVM.value, 'lobData.speLinLine.selectedOffering_Ext') === 'Sel') {
            result = availableValuesofCovType.filter((typecode) => typecode.name === 'PSLSelCovTyp')
        } else {
            result = availableValuesofCovType.filter((typecode) => typecode.name === 'otherThanSel')
        }

        if (_.isEmpty(result)) {
            return []
        }

        const res = result[0]?.codes?.map((typeCode) => ({
            code: typeCode.code,
            name: translator({
                id: typeCode.name,
                defaultMessage: typeCode.name
            })
        }))

        return res;
    };

    const generateAdditionalInterstsOverrides = () => {

        const getContactDisplayName = (contactPath) => {
            const contact = _.get(submissionVM, contactPath)
            if (contact) {
                return contact.displayName || `${contact.firstName} ${contact.lastName}`;
            }
            return ''
        };

        const overrides = additionalInterestsVM ? additionalInterestsVM.map((item, index) => ({
            [`additionalInterestRowHeader${index}`]: {
                content: `${getInterestRowTitle()} ${index + 1}`
            },
            [`proLineAddInterestFields${index}`]: {
                visible: sameAddlIntProduct.includes(submissionVM.value.baseData.productCode)
            },
            [`speLineAddInterestFields${index}`]: {
                visible: submissionVM.value.baseData.productCode === 'SpeLinProduct'
            },
            [`rvAddInterestFields${index}`]: {
                visible: submissionVM.value.baseData.productCode === 'RecVehProduct'
            },
            [`eveLiaLineAddInterestFields${index}`]: {
                visible: submissionVM.value.baseData.productCode === 'EveLiaProduct'
            },
            [`spaAndWellLineAddInterestFields${index}`]: {
                visible: submissionVM.value.baseData.productCode === 'SpaAndWelProduct'
            },
            [`additionalInterestName${index}`]: {
                value: getContactDisplayName(`${path}.value.${index}.${interestPath}`)
            },
            [`additionalInterestAddress${index}`]: {
                visible: type !== 'additionalInsured'
            },
            [`additionalInterestType${index}`]: {
                label: translator(messages.additionalInterestType),
                visible: type !== 'additionalInsured'
            },
            [`relationshipToInsured${index}`]: {
                visible: type === 'additionalInsured',
                label: translator(messages.additionalInsuredType)

            },
            [`editContainer${index}`]: {
                visible: (editIndex === index)
            },
            [`editAdditionalInterestBtn${index}`]: {
                onClick: () => { onEditContactClick(index) },
                ariaLabel: type === 'additionalInsured' ? translator(messages.editAdditionalInsured, { interestName: getContactDisplayName(`${path}.value.${index}.${interestPath}`) }) : translator(messages.editAdditionalInterest, { interestName: getContactDisplayName(`${path}.value.${index}.${interestPath}`) }),
                disabled: !!(isAddNewContact || editContact || isSearchContact)
            },
            [`deleteAdditionalInterestBtn${index}`]: {
                onClick: () => { deleteAdditionalInterest(index); },
                ariaLabel: type === 'additionalInsured' ? translator(messages.deleteAdditionalInsured, { interestName: getContactDisplayName(`${path}.value.${index}.${interestPath}`) }) : translator(messages.deleteAdditionalInterest, { interestName: getContactDisplayName(`${path}.value.${index}.${interestPath}`) }),
                disabled: !!(isAddNewContact || editContact || isSearchContact)
            },
            [`editAdditionalInterest${index}`]: {
                visible: (editIndex === index && editContact),
                contactVM: editContact,
                setComponentValidation,
                viewModelService,
                isDOBMandatory: type !== 'additionalInsured' && type !== 'additionalInterest',
                onValueChange: (value, changedPath) => { onContactUpdate(value, changedPath, index) },
                type

            },
            [`saveEditContact${index}`]: {
                onClick: () => { onSaveEditContact(index) },
                tabindex: !(editContact && editContact.aspects.valid && editContact.aspects.subtreeValid) ? -1 : 0,
                disabled: !(editContact && editContact.aspects.valid && editContact.aspects.subtreeValid),

            },
            [`cancelEditContact${index}`]: {
                onClick: onCancelEditContact
            },
            [`licenseNumber${index}`]: {
                visible: _.get(contactVM, 'subtype.value') === 'Person'
            },
            [`licenseState${index}`]: {
                visible: _.get(contactVM, 'subtype.value') === 'Person'
            },
            [`proLineAddInterestFields${index}`]: {
                visible: sameAddlIntProduct.includes(submissionVM.value.baseData.productCode) && type !== 'additionalInsured'
            },
            [`envLineAddInterestFields${index}`]: {
                visible: submissionVM.value.baseData.productCode ===  'EnvProduct' && type !== 'additionalInsured'
            },
            [`desOfInt_EY${index}`]: {
                defaultValue: !['ProLinProduct', 'SpeLinProduct'].includes(_.get(submissionVM.value, 'baseData.productCode')) ?
                    (!_.isUndefined(submissionVM.baseData.preferredlanguage_Ext.value) &&
                        (submissionVM.baseData.preferredlanguage_Ext.value.code === PremierConstants.preferredFrenchCode)
                        ? translator(messages.aucunMsg) : translator(messages.noneMsg))
                    : undefined
            },
            [`scheduleItems_EY${index}`]: {
                defaultValue: !['ProLinProduct', 'SpeLinProduct'].includes(_.get(submissionVM.value, 'baseData.productCode')) ?
                    (!_.isUndefined(submissionVM.baseData.preferredlanguage_Ext.value) &&
                        (submissionVM.baseData.preferredlanguage_Ext.value.code === PremierConstants.preferredFrenchCode)
                        ? translator(messages.emplacementPrincipal) : translator(messages.primaryLocation))
                    : undefined
            },
            [`rvAddInterestFields${index}`]: {
                visible: submissionVM.value.baseData.productCode === 'RecVehProduct' && type !== 'additionalInsured'
            },
            [`eveLiaLineAddInterestFields${index}`]: {
                visible: submissionVM.value.baseData.productCode === 'EveLiaProduct' && type !== 'additionalInsured'
            },
            [`srLineAddInterestFields${index}`]: {
                visible: productCode === lineName[productCode] && type !== 'additionalInsured'
            },
            [`spaAndWellLineAddInterestFields${index}`]: {
                visible: submissionVM.value.baseData.productCode === 'SpaAndWelProduct' && type !== 'additionalInsured'
            },
            [`speLineAddInterestFields${index}`]: {
                visible: submissionVM.value.baseData.productCode === 'SpeLinProduct' && type !== 'additionalInsured'
            },
            [`wriNotNumOfDay${index}`]: {
                visible: _.get(submissionVM, 'lobData.proLine.selectedOffering_Ext.value') !== 'MisPro'
            },
            [`covTyp_EY${index}`]: {
                availableValues: getAvailValuesforSCCovType(),
                defaultValue: ['EnvProduct', 'SpeLinProduct'].includes(productCode) ? 'Lia' : undefined
            },
            [`arrAmoPro${index}`]: {
                visible: submissionVM.value.baseData.productCode === 'ProLinProduct' && type !== 'additionalInsured' && !_.isUndefined(item.arrears_EY.value) && item.arrears_EY.value
            }
        })) : [];
        return Object.assign({}, ...overrides);
    }

    const overrideProps = {
        '@field': {
            labelPosition: 'left',
            showRequired: true
        },
        additionalInterestHeading: {
            content: type === 'additionalInsured' ? translator(messages.additionalNamedInsureds) : translator(messages.additionalInterests),
            visible: false //! hideTitle,
        },
        additionalInterests: {
            path: `${path}.children`
        },
        additionalInterestRowHeader: {

        },
        additionalInsured: {
            visible: type === 'additionalInsured',
            availableValues: accountContacts,
            value: '',
            onValueChange: onAdditionalInterestChange,
            disabled: !!(isAddNewContact || editContact)
        },
        additionalInterest: {
            visible: type === 'additionalInterest',
            availableValues: accountContacts,
            value: '',
            onValueChange: onAdditionalInterestChange,
            disabled: !!(isAddNewContact || editContact)
        },
        additionalInterestTitle: {
            content: _.get(submissionVM, `${path}`) && _.get(submissionVM, `${path}`).value !== undefined && _.get(submissionVM, `${path}.children`).length === 0
                ? translator(messages.additionalNamedInsureds)
                : translator(messages.addAnotherAdditionNamesInsured)
        },
        addAdditionalInterestContainer: {
            visible: true
        },
        addAdditionalInterestTitle: {
            visible: additionalInterestsVM && additionalInterestsVM.length > 0,
            content: getAdditionalInterestTitle()
        },
        separatorHR: {
            visible: isSearchContact || !!(isAddNewContact && addContact)
        },
        searchContact: {
            visible: isSearchContact,
            viewModelService,
            authHeader,
            accountNumber,
            handleAddExistingContact: onAddExistingContact,
            handleCancel: onSearchCancel,
            type
        },
        addNewContainer: {
            visible: !!(isAddNewContact && addContact)
        },
        newContactType: {
            label: (type === 'additionalInsured') ? translator(messages.additionalInsuredType) : translator(messages.additionalInterestType)
        },
        addContact: {
            contactVM: addContact,
            setComponentValidation,
            viewModelService,
            isDOBMandatory: type !== 'additionalInsured' && type !== 'additionalInterest',
            onValueChange: handleAddContactChange,
            type
        },
        saveContactBtn: {
            visible: !!(isAddNewContact && addContact),
            tabindex: !(addContact && addContact.aspects.valid && addContact.aspects.subtreeValid) ? -1 : 0,
            disabled: !(addContact && addContact.aspects.valid && addContact.aspects.subtreeValid),
            onClick: onSaveContact
        },
        cancelAddContactBtn: {
            onClick: onCancelAddContactClick
        },
        ...generateAdditionalInterstsOverrides()
    };
    const resolvers = {
        resolveCallbackMap: {},
        resolveComponentMap: {
            searchContactComponent: SearchContactComponent,
            contactComponent: ContactComponent
        },
        resolveClassNameMap: styles
    }


    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={submissionVM}
            overrideProps={overrideProps}
            onModelChange={onValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
            onValidationChange={setComponentValidation}
        />
    );
}

AdditionalInterestComponent.propTypes = {
    value: PropTypes.shape({}).isRequired,
    onValueChange: PropTypes.func.isRequired,
    onValidate: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired
};

export default withViewModelService(AdditionalInterestComponent);